import { abortable as abortableBase } from "@enfusion-ui/utils";
export default (restServer) => {
    const abortable = (c) => abortableBase(restServer, c);
    return {
        GET_CUSTOM_BENCHMARKS: abortable(() => "/internal/api/marketdata/custombenchmarks"),
        GET_CUSTOM_BENCHMARKS_PATH: () => "/internal/api/marketdata/custombenchmarks",
    };
};
